import { render } from "./FormLinedTextarea.vue?vue&type=template&id=75a61fea"
import script from "./FormLinedTextarea.vue?vue&type=script&lang=js"
export * from "./FormLinedTextarea.vue?vue&type=script&lang=js"
script.render = render

export default script